// fette-t3-theme — main JS entry (Webpack V12 mode)
//
// Pattern aligned with tc-base-v1: alle Vendor-Libs sequentiell laden
// (jQuery → Popper → Bootstrap → Plugins), DANACH Application-Module —
// damit Module/Main.js + Module/Custom.js auf das volle jQuery-Ökosystem
// zugreifen können. Pre-built ES5-Vendor-Files registrieren ihre Plugins
// als Side-Effect auf `window.jQuery.fn` (slick, select2, matchHeight,
// isotope) — ohne await wären die `.slick()`/`.select2()`-Calls in Module/
// "not a function".

(async () => {
  // Core (immer): jQuery → Popper → Bootstrap
  // Der gebündelte Vendor-jQuery setzt unter Webpack nur module.exports
  // (UMD-noGlobal), NICHT window.jQuery. Die ES5-Plugins (slick/select2/
  // matchHeight/isotope) und Module/Custom.js erwarten aber den GLOBAL
  // `jQuery`/`$` → sonst "ReferenceError: Can't find variable: jQuery" und das
  // Hauptmenü/JS bricht. Daher explizit global setzen, BEVOR Plugins + Module.
  const jqModule = await import('./Vendor/jquery-3.7.1.min.js');
  window.jQuery = window.$ = jqModule.default ?? jqModule;
  await import('./Vendor/popper.min.js');
  await import('./Vendor/bootstrap.min.js');

  // jQuery-Plugins: registrieren sich an $.fn beim Load. Reihenfolge spielt
  // hier untereinander keine Rolle, aber alle MÜSSEN vor App-Module fertig
  // sein. Sequential await statt Promise.all damit Stack-Traces lesbar
  // bleiben und Webpack-Chunks deterministisch initialisiert werden.
  await import('./Vendor/slick.js');
  await import('./Vendor/select2.js');
  await import('./Vendor/jquery.matchHeight.js');
  await import('./Vendor/isotope.pkgd.min.js');

  // Lottie-Player (web-component) — auf jeder Seite registrieren, billig.
  await import('./Vendor/lottie-player.min.js');
  await import('./Vendor/lottie-interactivity.min.js');

  // Application code: Module/Main.js + Module/Custom.js benutzen
  // jQuery(document).ready(...) Top-Level — wir laden sie erst nachdem alle
  // Plugins registriert sind. Wenn DOM bereits ready, ruft .ready() den
  // Callback synchron auf.
  await import('./Module/Main.js');
  await import('./Module/Custom.js');
})();
